function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { connect } from "react-redux";
import ToggleActionForm from "./ToggleActionForm";
import { Button } from "../../../general/Buttons";
import ToggleOpenTrigger from "./ToggleOpenTrigger";
import sanitizeHtml from 'sanitize-html';
import ToggleActionFormButtonContainer from "./ToggleActionFormButtonContainer";

class ToggleAction extends React.PureComponent {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      formOpen: this.props.formOpen,
      text: ""
    });

    _defineProperty(this, "openForm", () => {
      this.setState({
        formOpen: true
      });
    });

    _defineProperty(this, "closeForm", e => {
      this.setState({
        formOpen: false
      });
    });

    _defineProperty(this, "handleInputChange", e => {
      this.setState({
        text: !!e.target ? e.target.value : e
      });
    });

    _defineProperty(this, "handleAction", () => {
      const {
        text
      } = this.state;

      if (this.props.allowEmpty) {
        this.props.handleAction(text);
      } else {
        if (!!text) {
          this.props.handleAction(text);
        } else {
          this.setState({
            text: this.props.value
          });
        }
      }

      if (this.props.clearAfterAction) {
        this.setState({
          text: ""
        });
      }

      this.closeForm();
    });

    _defineProperty(this, "renderActionForm", () => {
      if (!!this.props.actionForm) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.actionForm, /*#__PURE__*/React.createElement(ToggleActionFormButtonContainer, {
          closeForm: this.closeForm
        }, /*#__PURE__*/React.createElement(Button, {
          color: 'primary',
          size: 'sm',
          onClick: this.closeForm,
          type: 'button'
        }, "confirm")));
      }

      return /*#__PURE__*/React.createElement(ToggleActionForm, {
        text: this.state.text,
        onChange: this.handleInputChange,
        closeForm: this.closeForm,
        placeholder: this.props.placeholder,
        submit: this.handleAction,
        editor: this.props.editor,
        cypress: this.props.cypress
      }, /*#__PURE__*/React.createElement(Button, {
        color: 'info',
        size: 'sm',
        onClick: this.handleAction,
        type: 'button',
        cypress: `${this.props.cypress}Submit`
      }, this.props.submitText));
    });
  }

  componentDidMount() {
    if (!!this.props.value) {
      this.setState({
        text: this.props.value
      });
    }
  }

  render() {
    const sanitizedHtml = sanitizeHtml(this.props.trigger, {
      allowedTags: ['b', 'i', 'em', 'strong', 'a', 's', 'u', 'ol', 'li', 'ul', 'p', 'span', 'br'],
      allowedAttributes: {
        a: ['href', 'target'],
        p: ['class']
      }
    });
    return this.state.formOpen ? this.renderActionForm() : /*#__PURE__*/React.createElement(ToggleOpenTrigger, {
      onClick: this.openForm,
      withoutPadding: this.props.withoutPadding,
      cypress: this.props.cypress
    }, this.props.triggerSanitize ? /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: sanitizedHtml
      }
    }) : this.props.trigger);
  }

}

export default connect(null, {})(ToggleAction);